import {
  IonApp,
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonItem,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonSkeletonText,
} from "@ionic/react";
import React, { Component } from "react";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import "./style.css";
import { URLS } from "../../urls";
import Footer from "../../components/Footer";
import {
  findPlayerByProp,
  getPlayersByRoles,
  getUserGameBet,
  getUserLastBet,
  getUserTournamentBet,
  sortByProp,
} from "../../calcScore";

declare const window, document: any;

const NAME_SEPERATOR = ",";

class MyTeam extends Component {
  state = {
    cost: 0,
    problem: "",
    fb: Firebase.getInstance(),
    roles: [],
    data: [] as any,
    user: {} as any,
    userBets: {} as any,
    lastBet: {} as any,
    betInLastGame: {} as any,
    choice: [] as any,
    difference: 0,
    tournamentID: "",
    gameID: "",
  };

  _isMounted = true;
  interval;
  isEditor = false;
  isBackButtonClicked = false;

  onBackButtonEvent = (e) => {
    e.preventDefault();

    if (!this.isBackButtonClicked) {
      if (document.getElementsByClassName("alert-radio-label").length !== 0) {
        document.getElementsByClassName("alert-button-role-cancel")[0].click();
        window.history.pushState(null, null, window.location.pathname);
      } else if (
        this.state.choice.length === 0 ||
        (this.state.lastBet.choice &&
          this.state.choice
            .map((p) => {
              return p.playerNumber;
            })
            .toString() === this.state.lastBet.choice.toString()) ||
        window.confirm("ישנם שינויים שלא נשמרו. האם ברצונך לעזוב את הדף?")
      ) {
        this.isBackButtonClicked = true;
        window.history.back();
      } else {
        window.history.pushState(null, null, window.location.pathname);
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBackButtonEvent);
    clearInterval(this.interval);
    this._isMounted = false;
  }

  async componentDidMount() {
    document.dispatchEvent(new Event("pageMount"));

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", this.onBackButtonEvent);

    var data = await this.state.fb.readData("data");
    var user = await this.state.fb.readData("users/public/$uid");
    var userBets = await this.state.fb.readData("users/bets/$uid");
    this.isEditor = await this.state.fb.isEditor();

    const roles = getPlayersByRoles(data);
    var needToChoose = 0;
    roles.map((roleValue: any) => {
      needToChoose += parseInt(data.Positions[roleValue.positionID].needToChoose);
    });
    var choice: any = [];
    for (let i = 0; i < needToChoose; i++) choice.push({});

    if (!this._isMounted) return;
    this.setState({ roles, data, user, userBets });
    this.calcSum();

    setTimeout(() => {
      var tournamentID = new URL(window.location).searchParams.get("tournamentID");
      if (!tournamentID) tournamentID = data.Games[(getUserLastBet(user) as any)?.gameID]?.tournamentID;
      if (!tournamentID) tournamentID = document.getElementsByClassName("myteam__selectTournamentOption")[0].value;
      document.getElementById("selectTournament").value = tournamentID;
    }, 1);

    this.interval = setInterval(() => {
      const labels: any = document.getElementsByClassName("alert-radio-label");
      const maxCost = this.state.data.Misc.maxMoneyPerBet;

      var checkedPlayer: any = "";
      for (let i = 0; i < labels.length; i++)
        if (labels[i].parentElement.parentElement.ariaChecked === "true") {
          checkedPlayer =
            this.state.data.Players[
              labels[i].parentElement.parentElement.className.split("playerNumber_")[1].split(" ")[0]
            ];
          break;
        }

      for (let i = 0; i < labels.length; i++) {
        if (labels[i].parentElement.childElementCount === 2) {
          let img: any = document.createElement("img");
          let playerNumber = labels[i].parentElement.parentElement.className.split("playerNumber_")[1].split(" ")[0];
          let imgUrl = this.state.data.Players[playerNumber].picture;
          let playerCost = this.state.data.Players[playerNumber].cost;
          if (
            (checkedPlayer && maxCost < this.state.cost - checkedPlayer.cost + parseInt(playerCost)) ||
            (!checkedPlayer && maxCost < this.state.cost + parseInt(playerCost))
          )
            labels[i].style.color = "orangered";
          img.src = imgUrl;
          img.classList.add("myteam__selectSearchIcon");
          img.onclick = () => {
            const player = findPlayerByProp(
              this.state.data,
              "playerName",
              labels[i].innerText.split(NAME_SEPERATOR)[0].trim()
            );
            window.open(window.location.origin + URLS.PLAYER.url + "/" + player.playerNumber);
          };
          labels[i].parentElement.appendChild(img);
        }
      }
    }, 100);
  }

  updateChoice = (playerIDs: any) => {
    const selects: any = document.getElementsByClassName("myteam__selectPlayer");
    for (let i = 0; i < selects.length; i++) {
      selects[i].value = playerIDs[i];
    }
    const choice = this.createChoiceFromPlayerID(playerIDs);
    if (!this._isMounted) return;
    this.setState({ choice });
    setTimeout(() => {
      this.calcSum();
    }, 0);
    return choice;
  };

  createChoiceFromPlayerID = (playerIDs: any) => {
    return Object.values(playerIDs).map((value: any) => {
      return findPlayerByProp(this.state.data, "playerNumber", value);
    });
  };

  save = async () => {
    const choiceIDs: any = [];
    this.state.choice.forEach((player: any) => {
      choiceIDs.push(player.playerNumber);
    });

    if (!this.state.problem) {
      const date = new Date();
      const res = await this.state.fb.setData("users/bets/$uid/" + date.getTime(), {
        time: date.getTime(),
        choice: choiceIDs,
        gameID: this.state.gameID,
      });
      if (res.code === "PERMISSION_DENIED") {
        alert(res.code);
      } else {
        await this.state.fb.analyticsEvent("save_bet", {
          tournamentID: this.state.tournamentID,
          gameID: this.state.gameID,
        });
      }
      window.location.pathname = "/";
    }
  };

  calcSum = () => {
    if (!this.state.tournamentID || !this.state.gameID) return;
    setTimeout(() => {
      const inputs: any = document.getElementsByClassName("myteam__selectPlayer");
      var cost: any = 0;
      var problem = "";
      var difference = 0;
      var groupsCount: any = {};

      const limitForSameGroupExcept = this.state.data.Positions.filter((pos: any) => {
        if (pos.limitForSameGroup === "F") return pos;
      });
      const limitForSameGroupExceptNames: any = [];
      limitForSameGroupExcept.forEach((pos: any) => {
        limitForSameGroupExceptNames.push((pos as any).description);
      });

      const playerPool = new Set();

      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].value /*&& inputs[i].shadowRoot.firstChild.part.value === "text"*/) {
          var find: any = findPlayerByProp(this.state.data, "playerNumber", inputs[i].value);
          cost += parseInt(find.cost);

          if (!(find.teamNumber in groupsCount)) groupsCount[find.teamNumber] = 1;
          else groupsCount[find.teamNumber]++;

          if (
            this.state.data.Positions[find.positionID] &&
            this.state.data.Positions[find.positionID].changesIncluded === "T" &&
            this.state.betInLastGame.choice &&
            !this.state.betInLastGame.choice.includes(inputs[i].value)
          )
            difference++;
          if (
            this.state.data.Positions[find.positionID] &&
            this.state.data.Positions[find.positionID].limitForSameGroup === "T" &&
            groupsCount[find.teamNumber] > this.state.data.Misc.maxPlayersFromSameTeam
          ) {
            problem =
              "אין לבחור יותר מ-" +
              this.state.data.Misc.maxPlayersFromSameTeam +
              " שחקנים מאותה הקבוצה (לא כולל " +
              limitForSameGroupExceptNames.toString() +
              ")";
          }
          if (playerPool.has(find.playerNumber)) {
            problem = "אין לבחור באותו שחקן פעמיים";
          }
          playerPool.add(find.playerNumber);
        } else problem = "יש לבחור את כל התפקידים לפני שליחה";
      }
      if (cost > this.state.data.Misc.maxMoneyPerBet) problem = "חרגת מן התקציב";
      if (this.state.difference > this.state.data.Misc.maxChangesAllowed)
        problem = "ביצעת יותר מידי שינויים ביחס לבחירתך הקודמת";

      if (
        new Date(this.state.data.Games[this.state.gameID].lastTimeToBet) < new Date() ||
        (new Date(this.state.data.Games[this.state.gameID].firstTimeToBet) > new Date() && !this.isEditor)
      )
        problem = "לא ניתן לבצע שינויים נוספים כעת!";
      this.setState({ cost, problem, difference });
    }, 100);
  };

  renderSelect = () => {
    const obj: any = [];
    var needToChooseIdx = 0;
    this.state.roles.map((roleValue: any, roleIndex) => {
      {
        sortByProp(roleValue.players, "cost", false);

        let needToChoose = this.state.data.Positions[roleValue.positionID].needToChoose;
        for (let chooseIdx = 0; chooseIdx < needToChoose; chooseIdx++) {
          const needToChooseIdxConst = needToChooseIdx;
          needToChooseIdx++;
          obj.push(
            <IonRow key={"row" + roleIndex + chooseIdx}>
              <IonCol className="myteam__col myteam__col1">
                {roleValue.description + (needToChoose > 1 ? " " + (chooseIdx + 1) : "")}
              </IonCol>
              <IonCol className="myteam__col myteam__col2">
                <IonSelect
                  className="myteam__selectPlayer"
                  placeholder="בחירה"
                  disabled={!this.state.gameID}
                  onIonChange={(e: any) => {
                    var choice = [...this.state.choice];
                    choice[needToChooseIdxConst] = findPlayerByProp(this.state.data, "playerNumber", e.detail.value);
                    this.setState({ choice });
                    setTimeout(() => {
                      this.calcSum();
                    }, 10);
                  }}
                >
                  {roleValue.players.map((playerValue: any, playerIndex: any) => {
                    if (
                      this.state.data.Teams[playerValue.teamNumber].leagueID ===
                      this.state.data.Games[this.state.gameID]?.leagueID
                    )
                      return (
                        <IonSelectOption
                          value={playerValue.playerNumber}
                          key={"option" + roleIndex + playerIndex}
                          className={"playerNumber_" + playerValue.playerNumber}
                        >
                          {playerValue.playerName}
                          {NAME_SEPERATOR} {playerValue.cost}
                          {NAME_SEPERATOR} {this.state.data.Teams[playerValue.teamNumber].teamName}
                        </IonSelectOption>
                      );
                  })}
                </IonSelect>
              </IonCol>
            </IonRow>
          );
        }
      }
    });
    return <div>{obj}</div>;
  };

  render() {
    return (
      <IonApp>
        <Toolbar />
        <IonContent>
          <br />
          <div className="home__message">{this.state.data.Misc?.homeMsg}</div>
          <div className="home__message">
            {this.state.data.Tournaments && this.state.data.Tournaments[this.state.tournamentID]?.homeMsg}
          </div>
          <br />
          <IonSelect
            id="selectTournament"
            placeholder="בחירת טורניר"
            interface="popover"
            className="myteam__selectGame"
            onIonChange={(e: any) => {
              this.updateChoice({});
              setTimeout(() => {
                this.setState({ tournamentID: e.detail.value });
                const gameSelect: any = document.getElementById("gameSelect");
                gameSelect.value = gameSelect.children[gameSelect.children.length - 1].value;
              }, 0);
            }}
          >
            {this.state.data.Tournaments &&
              Object.values(this.state.data.Tournaments)?.map((tournamentValue: any, tournamentIndex: any) => {
                if (tournamentValue)
                  return (
                    <IonSelectOption
                      className="myteam__selectTournamentOption"
                      value={tournamentValue.tournamentID}
                      key={"tournament" + tournamentIndex}
                    >
                      {tournamentValue.tournamentDesc}
                    </IonSelectOption>
                  );
              })}
          </IonSelect>
          <br />
          <IonSelect
            id="gameSelect"
            placeholder="בחירת מחזור"
            interface="popover"
            className="myteam__selectGame"
            disabled={!this.state.tournamentID}
            onIonChange={async (e: any) => {
              const gameID = e.detail.value;
              await this.setState({ gameID });
              this.setState({ lastBet: {}, betInLastGame: {} });
              if (!this.state.tournamentID || !gameID) {
                this.updateChoice({});
                return;
              }

              /*var lastBet: any = {};
                            var betInLastGame: any = {};
                            for (let key in this.state.userBets) {
                                let bet = this.state.userBets[key];
                                // console.log(bet);

                                if (
                                    parseInt(bet.gameID) < parseInt(gameID) &&
                                    this.state.data.Games[bet.gameID].tournamentID ==
                                        this.state.tournamentID &&
                                    (betInLastGame.gameID === undefined || bet.gameID >= betInLastGame.gameID)
                                )
                                    betInLastGame = bet;
                                if (bet.gameID == gameID) lastBet = bet;
                            }
                            console.log(betInLastGame);
                            console.log(lastBet);*/

              //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              var lastBet = getUserGameBet(this.state.userBets, gameID) || {};
              var betInLastGame =
                getUserTournamentBet(this.state.data, this.state.userBets, this.state.tournamentID) || {};

              await this.setState({ betInLastGame, lastBet });

              if (Object.keys(lastBet).length > 0) this.updateChoice(lastBet.choice);
              else if (Object.keys(betInLastGame).length > 0) this.updateChoice(betInLastGame.choice);
              else this.updateChoice({});
            }}
          >
            {(() => {
              const obj: any = [];
              this.state.data.Games?.map((gameValue: any, gameIndex: any) => {
                const available = this.isEditor || new Date(gameValue.firstTimeToBet) <= new Date();
                if (gameValue.tournamentID == this.state.tournamentID && available)
                  obj.push(
                    <IonSelectOption value={gameValue.gameID} key={"game" + gameIndex}>
                      {gameValue.description}
                    </IonSelectOption>
                  );
              });
              if (obj.length === 0)
                obj.push(
                  <IonSelectOption className="myteam__noGames" disabled key="no games">
                    לא נמצאו מחזורים
                  </IonSelectOption>
                );
              return obj;
            })()}
          </IonSelect>
          <br />
          <IonGrid className="myteam__grid">{this.renderSelect()}</IonGrid>
          {this.state.roles.length === 0 ? (
            <IonGrid className="myteam__grid">
              {Array.from(Array(6).keys()).map((i: any) => {
                return (
                  <IonItem key={"skeleton" + i}>
                    <IonSkeletonText animated />
                  </IonItem>
                );
              })}
            </IonGrid>
          ) : (
            ""
          )}
          <br />
          {this.state.gameID && this.state.problem ? (
            <div>
              <div style={{ textAlign: "center", color: "orangered", fontWeight: "bold" }}>{this.state.problem}</div>
              <br />
            </div>
          ) : (
            <div />
          )}
          {this.state.lastBet.time ? (
            <div>
              <div style={{ textAlign: "center" }}>
                השינוי האחרון התבצע בתאריך {new Date(this.state.lastBet.time).toLocaleDateString("he-IL")} בשעה{" "}
                {new Date(this.state.lastBet.time).toLocaleTimeString("he-IL")}
              </div>
              <br />
            </div>
          ) : (
            <div />
          )}
          {this.state.gameID ? (
            <div style={{ textAlign: "center" }}>
              ניתן לשנות את הבחירה עד לתאריך{" "}
              {new Date(this.state.data.Games[this.state.gameID].lastTimeToBet).toLocaleDateString("he-IL")} בשעה{" "}
              {new Date(this.state.data.Games[this.state.gameID].lastTimeToBet).toLocaleTimeString("he-IL")}
            </div>
          ) : (
            <div />
          )}
          <br />
          {this.state.gameID ? (
            <div style={{ textAlign: "center" }}>
              תקציב: {this.state.cost} מתוך {this.state.data.Misc ? this.state.data.Misc.maxMoneyPerBet : ""}
            </div>
          ) : (
            <div />
          )}
          <br />
          {this.state.betInLastGame.choice ? (
            <div>
              <div style={{ textAlign: "center" }}>
                שינויים שנעשו: {this.state.difference} מתוך{" "}
                {this.state.data.Misc ? this.state.data.Misc.maxChangesAllowed : ""}
              </div>
              <br />
            </div>
          ) : (
            <div />
          )}

          {this.state.gameID ? (
            <IonButton disabled={this.state.problem !== ""} onClick={this.save}>
              שליחה
            </IonButton>
          ) : (
            <div />
          )}
          <br />
          {this.state.betInLastGame.choice ? (
            <IonButton
              className="myteam__reset_btn"
              onClick={() => {
                this.updateChoice(this.state.betInLastGame.choice);
              }}
            >
              איפוס שינויים
            </IonButton>
          ) : (
            <div />
          )}
          <br />
          <Footer />
        </IonContent>
      </IonApp>
    );
  }
}

export default MyTeam;
